// Visual layer walkthrough and an exact Shopify-variant preview.
if (!customElements.get('cc-layer-story')) {
  customElements.define('cc-layer-story', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !active;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next], true);
        });
      });
    }
  });
}
if (!customElements.get('cc-savings-comparison')) {
  customElements.define('cc-savings-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.priceCents = Number(this.dataset.startPrice);
      const currency = this.dataset.currency || 'USD';
      const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
      const budget = this.querySelector('input');
      const reset = this.querySelector('[data-benchmark-reset]');
      this.size = 'Queen';
      this.customBudget = currency !== 'USD';
      this.applyBenchmark = () => {
        if (currency !== 'USD') return;
        budget.value = this.size === 'King' ? this.dataset.kingAverage : this.dataset.queenAverage;
        this.customBudget = false;
        reset.hidden = true;
      };
      this.update = () => {
        const dollars = budget.valueAsNumber;
        const label = this.querySelector('[data-cost-label]');
        const result = this.querySelector('[data-cost-difference]');
        if (!budget.validity.valid || !Number.isFinite(dollars) || !Number.isFinite(this.priceCents)) {
          label.textContent = 'Price difference';
          result.textContent = 'Enter a price above';
          return;
        }
        const difference = Math.round(dollars * 100) - this.priceCents;
        label.textContent = difference > 0 ? 'You could save' : difference < 0 ? 'Topper costs more' : 'Same price';
        result.textContent = money(Math.abs(difference));
      };
      this.selectionChanged = event => {
        this.priceCents = event.detail.priceCents;
        this.size = event.detail.size;
        this.querySelector('[data-benchmark-summary]').textContent = currency === 'USD'
          ? `Average of five ${this.size.toLowerCase()} models.`
          : 'Enter a price in your currency. Our research prices below are in USD.';
        if (!this.customBudget) this.applyBenchmark();
        this.querySelector('[data-cost-price]').textContent = event.detail.price;
        this.querySelector('[data-cost-selection]').textContent = event.detail.selection;
        this.update();
      };
      document.addEventListener('cc:selection', this.selectionChanged);
      this.budgetEdited = () => {
        this.customBudget = true;
        reset.hidden = currency !== 'USD';
        this.update();
      };
      this.resetBenchmark = () => { this.applyBenchmark(); this.update(); };
      budget.addEventListener('input', this.budgetEdited);
      reset.addEventListener('click', this.resetBenchmark);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('cc:selection', this.selectionChanged);
      this.querySelector('input')?.removeEventListener('input', this.budgetEdited);
      this.querySelector('[data-benchmark-reset]')?.removeEventListener('click', this.resetBenchmark);
      this.ready = false;
    }
  });
}
if (!customElements.get('cc-comfort-preview')) {
  customElements.define('cc-comfort-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const feel = {
        'Soft': 'Plush give around shoulders and hips.',
        'Medium': 'Balanced cushioning with a responsive feel.',
        'Firm': 'A more stable, lifted surface feel.',
        'Memory Foam': 'Slower response that contours around you.',
        'Latex': 'Buoyant comfort that responds as you move.'
      };
      const update = () => {
        const size = this.querySelector('[data-size]').value;
        const left = this.querySelector('[data-left]').value;
        const right = this.querySelector('[data-right]').value;
        this.querySelector('[data-left-label]').textContent = left;
        this.querySelector('[data-right-label]').textContent = right;
        this.querySelector('[data-left-description]').textContent = feel[left] || '';
        this.querySelector('[data-right-description]').textContent = feel[right] || '';
        this.querySelector('[data-selection]').textContent = `${size} · ${left} / ${right}`;
        const match = variants.find(v => v.options[0] === size && v.options[1] === left && v.options[2] === right);
        this.querySelector('[data-selection-price]').textContent = match ? match.price : 'See product for availability';
        this.querySelector('[data-selection-stock]').textContent = match && !match.available ? 'This combination is currently sold out.' : '';
        this.querySelector('[data-selection-link]').href = match ? `/products/dual-topper?variant=${match.id}` : '/products/dual-topper';
        if (match) document.dispatchEvent(new CustomEvent('cc:selection', { detail: { size, priceCents: match.priceCents, price: match.price, selection: `${size} · ${left} / ${right}${match.available ? '' : ' · Sold out'}` } }));
      };
      this.addEventListener('change', update);
      update();
    }
  });
}
